import * as Models from "../.";
export interface ICommercialCustomerCaptureInformtaion {
  customerName: string;
  address: Models.Customer.Address.Address;
  emailAddress: string;
  phoneNumber: string;
  completionTime: Date;
  responseCode: number;
  responseMessage: string;
}

export class CommercialCustomerCaptureInformation
  implements ICommercialCustomerCaptureInformtaion {
  customerName: string;
  address: Models.Customer.Address.Address;
  emailAddress: string;
  phoneNumber: string;
  completionTime: Date;
  responseCode: number;
  responseMessage: string;
}
